import { Button } from 'antd';
import { FC } from 'react';

import { AppModal } from '@/common/components';
import { AppModalControlProps, BaseQueryParams } from '@/common/interfaces';

import { useGetSearchConsoleAnalyticsMutation } from '@/modules/Domains';

import { SearchConsoleAnalyticsResultView } from './SearchConsoleAnalyticsResultView';

interface Props {
  analyticsResult: (BaseQueryParams<typeof useGetSearchConsoleAnalyticsMutation>['data']) | null;
  modalCotrols: AppModalControlProps;
}

export const SearchConsoleAnalyticsResultContainer: FC<Props> = ({
  analyticsResult,
  modalCotrols
}) => {

  const handleOpenModal = (): void => {
    modalCotrols.open();
  };

  return (
    <>
      {
        !!analyticsResult && (
          <>
            <Button block onClick={ handleOpenModal } shape="round">
              Показати результат
            </Button>
            <AppModal
              controls={ modalCotrols }
              width={ '90vw' }
              title="Ефективність"
              footer={ false }
            >
              <SearchConsoleAnalyticsResultView result={ analyticsResult }/>
            </AppModal>
          </>
        )
      }
    </>
  );
};
